import React from 'react';
import { PlateInfoDTO } from 'business/models/Models';
import { FmlxChip } from 'fmlx-common-ui';
import { CircleIcon, ClockIcon, CloseOutlineIcon } from '@fmlx/icons';
import { HexColors } from 'constants/colors';
import './PlateUtils.scss';
import { EPlateState } from 'enums/EPlatestate';

export const renderPlateChip = (plate: PlateInfoDTO, showExpired: boolean = false) => {
  const imagerName = plate.robotName;
  const isExpired = showExpired && plate.plateState === EPlateState.Expired;

  if (imagerName) {
    return (
      <FmlxChip
        id={`plate-status-loaded-${plate.id}`}
        type={FmlxChip.Type.SAFE}
        variant={FmlxChip.Variant.OUTLINED}
        size={FmlxChip.Size.SMALL}
        label={'Loaded'}
        leftIcon={
          <CircleIcon
            customColor={HexColors.green[4]}
            customSize={12}
            id={`plate-status-loaded-icon-${plate.id}`}
          />
        }
      />
    );
  }

  if (isExpired) {
    return (
      <FmlxChip
        id={`plate-status-expired-${plate.id}`}
        type={FmlxChip.Type.DANGER}
        variant={FmlxChip.Variant.OUTLINED}
        size={FmlxChip.Size.SMALL}
        label={'Expired'}
        leftIcon={
          <CloseOutlineIcon
            customColor={HexColors.red[4]}
            customSize={12}
            id={`plate-status-expired-icon-${plate.id}`}
          />
        }
      />
    );
  }

  return (
    <FmlxChip
      id={`plate-status-not-imaged-${plate.id}`}
      type={FmlxChip.Type.DEFAULT}
      variant={FmlxChip.Variant.OUTLINED}
      size={FmlxChip.Size.SMALL}
      label={'Ejected'}
      leftIcon={
        <ClockIcon
          customColor={HexColors.blue[4]}
          customSize={12}
          id={`plate-status-not-imaged-icon-${plate.id}`}
        />
      }
    />
  );
};
